import React, {
  useState,
  useMemo,
  Fragment,
  memo,
  useEffect,
  useCallback,
  useContext,
} from "react";
import Countdown from "react-countdown";
import _ from "lodash";
import {
  useTable,
  usePagination,
  useFilters,
  useGlobalFilter,
  useSortBy,
  useRowSelect,
} from "react-table";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog } from "@headlessui/react";
import { Switch } from "@blueprintjs/core";
import { EmitterStatus } from "../../event";

import { API, Auth, Storage } from "aws-amplify";

const Row = ({ row, i, value, getData, where, labelName, isPrivillege }) => {
  const { user } = useSelector((state) => state.initializeApp);
  const [showModal, setShowModal] = useState(false);

  console.log("VALUE", value);

  return (
    <Fragment>
      <tr
        {...row.getRowProps()}
        onClick={() => setShowModal(true)}
        className={classNames(
          "cursor-pointer hover:bg-blueGray-200 transition-all duration-300",
          {
            "bg-white": i % 2 === 0,
            "bg-gray-100": i % 2 !== 0,
          }
        )}
      >
        {row.cells.map((cell, index) => {
          return (
            <td
              className={"p-4 text-gray-700 text-sm text-center"}
              {...cell.getCellProps()}
            >
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>
      <HolidayDialog
        promotion_key={value.promotion_key}
        consume={Boolean(value.consume)}
        tour={Boolean(value.tour)}
        business={Boolean(value.business)}
        description={value.description}
        value={value.value}
        beginDate={value.beginDate}
        endDate={value.endDate}
        showModal={showModal}
        setShowModal={setShowModal}
        getData={getData}
        where={where}
        isCreate={false}
        labelName={labelName}
        isPrivillege={isPrivillege}
      />
    </Fragment>
  );
};

const HolidayDialog = ({
  showModal,
  setShowModal,
  getData,
  where,
  isCreate = true,
  promotion_key = "",
  description = "",
  value = "",
  consume = true,
  tour = true,
  business = true,
  beginDate = "",
  endDate = "",
  isPrivillege,
  labelName,
}) => {
  const [error, setError] = useState(false);
  const [form, setForm] = useState({
    promotion_key: promotion_key,
    description: description,
    value: value,
    consume: consume,
    tour: tour,
    business: business,
    beginDate: beginDate,
    endDate: endDate,
  });

  const onSubmit = async () => {
    const result = await Swal.fire({
      title: "คุณยืนยันที่จะอนุมัติรายการนี้หรือไม่ ?",
      showCancelButton: true,
      confirmButtonText: `บันทึก`,
      cancelButtonText: "ยกเลิก",
      showLoaderOnConfirm: true,
      showLoaderOnDeny: false,
      preConfirm: async () => {
        try {
          if (
            !form.promotion_key ||
            !form.description ||
            !form.value ||
            !form.beginDate ||
            !form.endDate
          ) {
            setError(true);
            return {
              error: true,
            };
          }
          if (isCreate) {
            await API.post("MoneyHubAdmin", "/holiday/promotion", {
              body: {
                promotion_key: form.promotion_key,
                description: form.description,
                value: form.value,
                consume: form.consume,
                tour: form.tour,
                business: form.business,
                beginDate: form.beginDate,
                endDate: form.endDate,
                isPrivillege,
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            });
          } else {
            await API.put("MoneyHubAdmin", "/holiday/promotion", {
              body: {
                promotion_key: form.promotion_key,
                description: form.description,
                value: form.value,
                consume: form.consume,
                tour: form.tour,
                business: form.business,
                beginDate: form.beginDate,
                endDate: form.endDate,
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            });
          }
        } catch (error) {
          await EmitterStatus("ERROR", { logMessage: error });
        }
      },
    });
    if (result.value?.error) {
      return await EmitterStatus("WARNING");
    }
    if (!result.isConfirmed) return;
    await EmitterStatus("SUCCESS");
    console.log("IS", isPrivillege);
    await getData({ isPrivillege });
  };
  return (
    <Dialog
      open={showModal}
      className="fixed z-10 inset-0 overflow-y-auto"
      onClose={() => setShowModal(false)}
    >
      <div className="flex items-center justify-center min-h-screen">
        <div className="bg-white border border-gray-300 rounded max-w-sm mx-auto p-4 z-20">
          <Dialog.Title className="font-black text-lg">
            เพิ่ม / แก้ไข โปรโมชั่น
          </Dialog.Title>
          <Dialog.Description className="my-4">
            <div>
              <div className="w-32">ชื่อ</div>
              <input
                className="border border-gray-300 focus:outline-none px-3 py-2 rounded"
                type="text"
                name="promotion_key"
                disabled={!isCreate}
                placeholder="เช่น วันปีใหม่ หรือ TFG"
                value={form.promotion_key}
                onChange={(e) =>
                  setForm((prev) => {
                    return {
                      ...prev,
                      [e.target.name]: e.target.value,
                    };
                  })
                }
              />
              <span className="text-red-400 mx-2">
                {error && !form.promotion_key && "โปรดใส่วันที่หยุด"}
              </span>
            </div>
            <div>
              <div className="w-32">รายละเอียด</div>
              <input
                className="border border-gray-300 focus:outline-none px-3 py-2 rounded"
                type="text"
                name="description"
                placeholder="คำอธิบาย"
                value={form.description}
                onChange={(e) =>
                  setForm((prev) => {
                    return {
                      ...prev,
                      [e.target.name]: e.target.value,
                    };
                  })
                }
              />
              <span className="text-red-400 mx-2">
                {error && !form.description && "โปรดใส่รายละเอียด"}
              </span>
            </div>
            <div>
              <div className="w-32">ส่วนลด</div>
              <input
                className="border border-gray-300 focus:outline-none px-3 py-2 rounded"
                type="number"
                name="value"
                placeholder="เช่น -10 (หมายถึง -10% จากดอกเบี้ยหลัก เช่น 33 - 10 = 23%"
                value={form.value}
                onChange={(e) =>
                  setForm((prev) => {
                    return {
                      ...prev,
                      [e.target.name]: e.target.value,
                    };
                  })
                }
              />
              <span className="text-red-400 mx-2">
                {error && !form.value && "โปรดใส่ส่วนลด"}
              </span>
            </div>
            <div>
              <div className="w-32">วันที่เริ่ม</div>
              <input
                className="border border-gray-300 focus:outline-none px-3 py-2 rounded"
                type="date"
                name="beginDate"
                value={form.beginDate}
                onChange={(e) =>
                  setForm((prev) => {
                    return {
                      ...prev,
                      [e.target.name]: e.target.value,
                    };
                  })
                }
              />
              <span className="text-red-400 mx-2">
                {error && !form.beginDate && "โปรดใส่วันที่เริ่ม"}
              </span>
              <div className="w-32">วันที่สิ้นสุด</div>
              <input
                className="border border-gray-300 focus:outline-none px-3 py-2 rounded"
                type="date"
                name="endDate"
                value={form.endDate}
                onChange={(e) =>
                  setForm((prev) => {
                    return {
                      ...prev,
                      [e.target.name]: e.target.value,
                    };
                  })
                }
              />
              <span className="text-red-400 mx-2">
                {error && !form.endDate && "โปรดใส่วันที่สิ้นสุด"}
              </span>
            </div>
            <Switch
              checked={form.consume}
              label="อุปโภค / บริโภค"
              onChange={(e) => {
                setForm({ ...form, consume: !form.consume });
              }}
            />
            <Switch
              checked={form.tour}
              label="ท่องเที่ยว"
              onChange={(e) => {
                setForm({ ...form, tour: !form.tour });
              }}
            />
            {console.log(form.business)}
            <Switch
              checked={form.business}
              label="ธุรกิจ"
              onChange={(e) => {
                setForm({ ...form, business: !form.business });
              }}
            />
          </Dialog.Description>
          <button
            className="p-2 bg-blue-500 text-white w-20 mr-4 rounded"
            onClick={onSubmit}
          >
            ตกลง
          </button>
          <button
            className="p-2 text-blue-500 border border-blue-500 w-20 rounded"
            onClick={() => setShowModal(false)}
          >
            ยกเลิก
          </button>
        </div>
      </div>
    </Dialog>
  );
};

function PromotionTable({ data, getData, where, isPrivillege, labelName }) {
  const { user } = useSelector((state) => state.initializeApp);
  const [showModal, setShowModal] = useState(false);

  const onDelete = (row) => async (e) => {
    e.stopPropagation();

    try {
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะลบรายการนี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          await API.del("MoneyHubAdmin", `/holiday/promotion`, {
            queryStringParameters: {
              promotion_key: row.original.promotion_key,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        },
      });
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูลสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      await getData({ isPrivillege });
    } catch (error) {
      console.log("Error", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "รหัส",
        accessor: "promotion_key",
      },
      {
        Header: "ส่วนลด",
        accessor: "value",
      },
      {
        Header: "รายละเอียด",
        accessor: "description",
      },
      {
        Header: "วันเริ่ม",
        accessor: "beginDate",
        Cell: ({ row }) => {
          if (!row.original.beginDate) return <div>-</div>;

          return (
            <div>{format(new Date(row.original.beginDate), "dd-MM-yy")}</div>
          );
        },
      },
      {
        Header: "วันสิ้นสุด",
        accessor: "endDate",
        Cell: ({ row }) => {
          if (!row.original.endDate) return <div>-</div>;

          return (
            <div>{format(new Date(row.original.endDate), "dd-MM-yy")}</div>
          );
        },
      },
      {
        Header: "",
        accessor: "settings",
        Cell: ({ row }) => {
          return (
            <button
              className="mx-2 px-4 py-1 rounded text-white shadow-sm duration-300 transition-all focus:outline-none bg-red-500 hover:bg-red-600"
              onClick={onDelete(row)}
            >
              ลบ
            </button>
          );
        },
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  return (
    <div className="mx-4 mb-2">
      <div className="bg-white rounded border border-gray-300 w-full overflow-x-auto ">
        <table {...getTableProps()} className="w-full whitespace-no-wrap">
          <thead className=" text-sm font-semibold tracking-wide text-gray-500  border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, i) => (
                  <th
                    {...column.getHeaderProps()}
                    className={classNames("px-4 py-3 text-center", {
                      "rounded-tl": i === 0,
                      "rounded-tr": i === headerGroup.headers.length - 1,
                    })}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody
            className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800 text-gray-700 dark:text-gray-400"
            {...getTableBodyProps()}
          >
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <Row
                  where={where}
                  key={row.getRowProps().key}
                  i={i}
                  row={row}
                  value={data[i]}
                  getData={getData}
                  isPrivillege={isPrivillege}
                  labelName={labelName}
                />
              );
            })}
          </tbody>
        </table>
      </div>
      <button
        className="bg-blue-500 text-white round-xl p-2 my-4 w-full rounded"
        onClick={() => setShowModal(true)}
      >
        เพิ่มโปรโมชั่น
      </button>
      <HolidayDialog
        isPrivillege={isPrivillege}
        showModal={showModal}
        setShowModal={setShowModal}
        getData={getData}
        where={where}
        labelName={labelName}
      />
    </div>
  );
}

export default PromotionTable;
